"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _unmutable = _interopRequireDefault(require("./internal/unmutable"));

var _pick = _interopRequireDefault(require("./pick"));

var _default = (0, _unmutable.default)({
  name: 'slice',
  immutable: 'slice',
  object: function object() {
    var begin = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var end = arguments.length > 1 ? arguments[1] : undefined;
    return function (value) {
      var keys = Object.keys(value);
      var keysSliced = end || end === 0 ? keys.slice(begin, end) : keys.slice(begin);
      return (0, _pick.default)(keysSliced)(value);
    };
  },
  array: function array() {
    var begin = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var end = arguments.length > 1 ? arguments[1] : undefined;
    return function (value) {
      return end || end === 0 ? value.slice(begin, end) : value.slice(begin);
    };
  }
});

exports.default = _default;